import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement, query, queryAssignedElements } from 'lit/decorators.js';
import { styles, tag } from './side-panel.styles';

import './side-panel-aside.component';

@customElement(tag)
export class SidePanelComponent extends TmElement {
  static override styles = styles;

  @query('main')
  main!: HTMLElement;

  @queryAssignedElements({ slot: 'end', selector: 'a-side-panel-aside' })
  endAsidePanels!: Array<HTMLElement>;

  override render() {
    return html`
      <slot name="start"></slot>

      <main class="main" part="main">
        <slot></slot>
      </main>

      <slot name="end" @slotchange=${this.#endSlotChanged}></slot>
    `;
  }

  #endSlotChanged = () => {
    this.endAsidePanels.forEach((panel) => {
      // @ts-expect-error typing
      // eslint-disable-next-line no-param-reassign
      panel['position'] = 'end';
    });
  };

  override addEventListener<K extends keyof HTMLElementEventMap>(
    type: K,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listener: (this: HTMLElement, ev: HTMLElementEventMap[K]) => any,
    options?: boolean | AddEventListenerOptions,
  ) {
    if (type === 'scroll' || type === 'scrollend') {
      return this.main.addEventListener(type, listener, options);
    }

    return super.addEventListener(type, listener, options);
  }

  override scrollTo(options?: ScrollToOptions | number, y?: number): void {
    if (typeof options === 'number' && typeof y === 'number') {
      this.main.scrollTo(options, y);
    } else {
      this.main.scrollTo(options as ScrollToOptions);
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-side-panel': SidePanelComponent;
  }
}
